import { render } from "./MainPLansComponent.vue?vue&type=template&id=5ea0bb1c"
const script = {}

import "./MainPLansComponent.vue?vue&type=style&index=0&id=5ea0bb1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__